import { render, staticRenderFns } from "./roomhistory.vue?vue&type=template&id=6bedbdb2&scoped=true&"
import script from "./roomhistory.vue?vue&type=script&lang=js&"
export * from "./roomhistory.vue?vue&type=script&lang=js&"
import style0 from "./roomhistory.vue?vue&type=style&index=0&id=6bedbdb2&scoped=true&lang=scss&"
import style1 from "./roomhistory.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bedbdb2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDataTable,VRow})
